// extracted by mini-css-extract-plugin
export var coverSection = "Cover-module--coverSection--GYBkb";
export var coverVector = "Cover-module--coverVector--DH+v6";